import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IUploadFile } from "../models/master";
import { throwApiError } from "./apiError";


/**
 * Upload Image API call using Axios
 * @returns - Upload Investigation Image api and return same success message
 */

export const FileUploadAPI = async (files: File[] , params: IUploadFile) => {
  try {
    const formData = new FormData();
    // Append the file to the FormData instance
    files.forEach(file => {
      formData.append('files', file);
    });
    // Append proNumber to the FormData
    if (params.proNumber) {
      formData.append('proNumber', params.proNumber.toString());
    }
    const response = await axios.post(`${getUrl(ApiType.UPLOAD_FILE)}/${params.osdNumber}/${params.docType}/${params.uploadKey}`, formData);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.investigationImageUploadAPIError);
  }
};
